import React, { useCallback, useEffect, useMemo, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useOrganizationId } from "../../../context/Customfunction";
import {
  DeleteRamaStudentDetailApi,
  EmployeeeStatusChange,
  RamaStudentsListApi,
  RamaStudentStatusChange,
} from "../../../api/api";
import { SetPopupReducerData } from "../../../store/reducer/PopupReducer";
import CustomTable from "../../../ui/custom-table";
import { toast } from "react-toastify";

function Students() {
  const dispatch = useDispatch();
  const [students, setStudents] = useState([]);
  console.log("students", students);
  const orgId = useOrganizationId();
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const { showModal } = useSelector(
    (state) => state?.PopupReducer?.modal || {}
  );
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [totalRows, setTotalRows] = useState(0);
  const [debouncedSearch, setDebouncedSearch] = useState("");

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 500); // Debounce by 500ms

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  const fetchStudents = useCallback(async () => {
    setLoading(true);

    try {
      const page = pagination.pageIndex + 1;
      const limit = pagination.pageSize;
      const search = debouncedSearch;
      const data = await RamaStudentsListApi(page, limit, search);
      console.log(data);
      if (data?.data?.status === true) {
        setStudents(data?.data?.data || []);

        setTotalRows(data?.data?.pagination?.total || 0);
      }
    } catch (error) {
      console.error("Error fetching employees:", error);
    } finally {
      setLoading(false);
    }
  }, [orgId, pagination.pageIndex, pagination.pageSize, debouncedSearch]);

  useEffect(() => {
    fetchStudents();
  }, [pagination, debouncedSearch]);

  useEffect(() => {
    if (showModal === false) {
      fetchStudents();
    }
  }, [showModal, debouncedSearch]);

  const handleStausChange = async (id, status) => {
    let payload = {
      student_id: id,
      is_blocked: status === true ? false : true,
    };
    try {
      const data = await RamaStudentStatusChange(payload);
      if (data?.data?.status === true) {
        fetchStudents();
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const columns = useMemo(
    () => [
      { accessorKey: "student_name", header: " Name" },
      { accessorKey: "enrollment_number", header: "Enrollment Number" },

      {
        accessorKey: "student_image",
        header: "Student Image",
        Cell: ({ row }) => {
          const imagePath = row.original.student_image;
          const imageUrl = imagePath
            ? `https://visionemptrack.greymatterz.com/${imagePath}`
            : "";

          return (
            imageUrl && (
              <img
                src={imageUrl}
                alt="Employee"
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            )
          );
        },
      },
      {
        accessorKey: "Status",
        header: "status",
        Cell: ({ row }) => {
          const isActive = row.original.is_blocked;

          return (
            <div className="d-flex align-items-center gap-2">
              <label className="custom-toggle mb-0">
                <input
                  type="checkbox"
                  checked={isActive}
                  onChange={() => handleStausChange(row.original._id, isActive)}
                />
                <span className="slider"></span>
              </label>
              <span
                className={`fw-bold ${
                  isActive ? "text-success" : "text-danger"
                }`}
              >
                {isActive ? "Block" : "UnBlock"}
              </span>
            </div>
          );
        },
      },
      //   { accessorKey: "created_at", header: "Created At" },
    ],
    []
  );

  const handleAdd = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "ADDSTUDENT",
        showModal: true,
      })
    );
  };

  const handleEdit = (row) => {
    dispatch(
      SetPopupReducerData({
        modalType: "ADDSTUDENT",
        showModal: true,
        data: row._id,
      })
    );
  };

  const handelDelete = async (row) => {
    const data = await DeleteRamaStudentDetailApi(row._id);
    if (data) {
      toast("Record deleted successfully");
      fetchStudents();
    }
  };
  return (
    <aside className="mainSection">
      <CustomTable
        columns={columns}
        data={students}
        loading={loading}
        onAddClick={handleAdd}
        addButtonLabel="Add Student"
        showActions={true}
        onEdit={handleEdit}
        onDelete={handelDelete}
        pagination={pagination}
        onPaginationChange={(updater) => {
          setPagination((prev) => {
            const newPagination =
              typeof updater === "function"
                ? updater(prev)
                : { ...prev, ...updater };
            return newPagination;
          });
        }}
        rowCount={totalRows}
        searchTerm={searchTerm}
        onSearchChange={(e) => {
          setSearchTerm(e.target.value);
          setPagination({ pageIndex: 0, pageSize: 10 });
        }}
      />
    </aside>
  );
}

export default Students;
